module.exports = __webpack_public_path__ + "assets/media/video3.0b05401b.mp4";